interface IProps {
    pin: string;
}   

const PinIndicator = ({pin}: IProps) => {
    return (
        <div className="pin-indicators">
            {[...Array(6)].map((_, index) => (
                <div 
                    key={index} 
                    className={`pin-indicator ${index < pin.length ? 'active' : ''}`}
                ></div>
            ))}
        </div>
    );
}

export default PinIndicator;